var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChatCenteredText = function SvgIconChatCenteredText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 5.5V17h5.33a1.74 1.74 0 0 1 1.495.855L12 19.815l1.175-1.96A1.74 1.74 0 0 1 14.67 17H20V5.5zM2.513 4.013A1.75 1.75 0 0 1 3.75 3.5h16.5A1.75 1.75 0 0 1 22 5.25v12A1.75 1.75 0 0 1 20.25 19h-5.43l-1.315 2.195-.006.01a1.76 1.76 0 0 1-2.998 0l-.006-.01L9.18 19H3.75A1.75 1.75 0 0 1 2 17.25v-12c0-.464.184-.91.513-1.237M8 9.375a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1m0 3.75a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgIconChatCenteredText;